<template>
  <family-page-wrapper class="family-grocery-history">
    <div
      v-if="isOrderEmpty"
      class="order-empty-notification"
    >
      Please call us at
      <a href="tel:+18554646872">1-855-464-6872</a>
      if you would like to place your first order!
    </div>

    <grocery-search @set-empty-order="isOrderEmpty = $event" />
    <grocery-tranactions />
  </family-page-wrapper>
</template>

<script setup lang="ts">
import { ref, defineAsyncComponent } from 'vue';

const GrocerySearch = defineAsyncComponent(() => import('../Operator/Grocery/GrocerySearch.vue') as any);

const GroceryTranactions = defineAsyncComponent(() => import('../Operator/Grocery/Transactions.vue') as any);

const isOrderEmpty = ref(false);
</script>

<style lang="scss">
.family-grocery-history {
  .order-empty-notification {
    max-width: 960px;
    font-size: 18px;
    margin-bottom: 20px;
    text-align: center;
    color: #f00;

    a {
      color: #080fef;
      text-decoration: underline;
    }
  }
}
</style>
